import { css } from 'emotion';
import styled from '@emotion/styled';
import { ControlledFieldDatePicker } from 'components/FieldDatePicker';
import { FieldLabel } from 'components/FieldLabel';
import { SM_SCREEN_MAX } from 'modules/Styleguide';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { Button } from 'shared/Button/NewButton';

export const DatesContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 16px 0 50px;
  p {
    margin-bottom: 0;
    color: #5f6369;
  }
  button {
    padding: 0;
  }
  @media (max-width: ${SM_SCREEN_MAX}px) {
    display: block;
  }
`;

export const StyledDatePicker = styled(ControlledFieldDatePicker)`
  &:first-of-type {
    padding: 0 16px 0 0;
  }
  button {
    padding: 0;
    &:focus > div {
      border: 1px solid #702cd5;
    }
    > div {
      border: 1px solid transparent;
      &:focus {
        outline: 0;
      }
    }
  }
  @media (max-width: ${SM_SCREEN_MAX}px) {
    &:first-of-type {
      padding: 0;
    }
    button {
      width: 100%;
    }
  }
`;

export const InteractiveSectionContainer = styled.div`
  margin: 36px 40px 40px 40px;
  padding-bottom: 40px;
  border-bottom: 2px solid #dfe0e1;
`;

export const Title = styled.h3`
  display: inline-block;
  margin: 0 0 20px;
  padding: 0;
  font-weight: bold;
  font-size: 2rem;
  line-height: 23px;
`;

export const Optional = styled.span`
  color: #7f8287;
  font-weight: normal;
  font-size: 1.4rem;
`;

export const pollTypeClassName = css`
  max-width: 360px;
  margin: 16px 0;
  color: #292f36;
  font-weight: bold;
  font-size: 1.8rem;

  @media (max-width: ${SM_SCREEN_MAX}px) {
    label {
      font-size: 12px;
    }
  }
`;

export const OpenModalButton = styled(Button)`
  width: 200px;
  margin-top: 4px;
`;

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ThreeDotMenuContainer = styled(DropdownButton)`
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  &:hover,
  &:active,
  &:focus,
  &:active:focus {
    background: transparent !important;
    box-shadow: none !important;
  }
  svg > g > g {
    fill: #c9cbcd;
  }
  &:hover {
    svg > g > g {
      fill: #999;
    }
  }
`;

export const ThreeDotMenuItem = styled(MenuItem)<{ isWarning?: boolean }>`
  /* overrides react-bootstrap styling */
  a {
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 2.25;
    padding: 3px 20px;
    width: 240px;
    ${({ isWarning }) => (isWarning ? `color: #e54751;` : 'color: #333;')};
    align-items: center;
    display: flex;
    text-decoration: none;
  }
`;

export const CircularIconContainer = styled.div`
  width: 18px;
  height: 18px;
  padding: 4px;
  border-radius: 100%;
  background-color: #cccdcf;
`;

export const StatusText = styled.p`
  margin-bottom: 16px;
  color: #7f8287;
  font-weight: bold;
`;

export const RoundedCard = styled.div`
  padding: 36px;
  border-radius: 6px;
  background-color: white;
`;

export const BannerTitle = styled.h3`
  margin: 0 0 8px;
  color: #292f36;
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
`;

export const OptionsContainer = styled.div`
  margin-bottom: 36px;
`;

export const OptionsInputsGridContainer = styled.div`
  margin-bottom: 1.6rem;
`;

export const QuestionTitle = styled.p`
  margin: 22px 0 20px;
  font-weight: bold;
  font-size: 1.6rem;
`;

export const StyledFieldLabel = styled(FieldLabel)`
  margin-bottom: 8px;
  color: #292f36;
  font-weight: bold;
  font-size: 1.8rem;
`;
